import { cn } from '@/lib/utils';

export const ChipLabel = ({
  className,
  children,
  ...divProps
}: React.HTMLProps<HTMLDivElement>) => (
  <div
    className={cn(
      'ml-[5px] inline-flex select-none items-center whitespace-nowrap rounded-sm bg-light px-[5px] py-[2px] text-center font-mono text-gray-600 text-xs',
      className
    )}
    {...divProps}
  >
    {children}
  </div>
);
